module.exports = __webpack_public_path__ + "img/Atlantic front.846b4f6b.png";